/**
 * @description 最新消息 類型用
 */
export enum NewsType {
  /** 全部 */
  All='All',
  /** 公司公告 */
  Announcement = 'A',
  /** 部落客文章 */
  Article = 'B',
  /** 公司影音 */
  Video = 'V',
  /** 新聞稿 */
  Release = 'N'
}

/**
 * @description 最新消息列表 Section
 */
export enum NewsSectionType {
  /** 公司公告 */
  Announcement = 'A',
  /** 部落客文章 */
  Article = 'B',
  /** 公司影音 */
  Video = 'V',
  /** 新聞稿 */
  Release = 'N'
}
